/**
 * CTR Variant Picker – dynamic price + savings updates
 * Handles subscription vs one-time price recalculation for each variant card.
 */
(function () {
  function init() {
    var picker = document.querySelector('.ctr-variant-picker');
    if (!picker) return;

    var displays = picker.querySelectorAll('[data-variant-price-display]');
    if (!displays.length) return;

    /* ── Locate product JSON ── */
    var jsonEl =
      document.querySelector('[data-product-json]') ||
      document.querySelector('[data-ctr-price-product]') ||
      document.querySelector('[data-ctr-buy-button-product]');

    var productData = null;
    if (jsonEl) {
      try {
        productData = JSON.parse(jsonEl.textContent || jsonEl.innerHTML);
      } catch (e) {
        console.error('[ctr-variant-picker] Failed to parse product JSON', e);
        return;
      }
    }
    if (!productData) return;

    /* ── Helpers ── */
    function formatMoney(cents) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: productData.currency || 'USD',
        minimumFractionDigits: 2,
      }).format(cents / 100);
    }

    function getVariant(id) {
      return productData.variants.find(function (v) {
        return v.id == id;
      });
    }

    function isSubscription() {
      var el = document.querySelector('[data-purchase-option][value="subscription"]');
      return el && el.checked;
    }

    function calcPrices(variantId) {
      var v = getVariant(variantId);
      if (!v) return null;

      var current = v.price;
      var compare = v.compare_at_price;
      var sub = isSubscription();

      if (sub && v.selling_plan_allocations && v.selling_plan_allocations.length) {
        var alloc = v.selling_plan_allocations[0];
        if (alloc && alloc.price) current = alloc.price;
        compare = compare || v.price;
      }

      var savings = compare && compare > current ? compare - current : 0;
      var pct = compare && compare > 0 ? Math.round((savings / compare) * 100) : 0;

      return { current: current, compare: compare, savings: savings, pct: pct };
    }

    /* ── Update a single card ── */
    function updateCard(display) {
      var id = display.dataset.variantId;
      var prices = calcPrices(id);
      if (!prices) return;

      var curEl = display.querySelector('[data-price-current]');
      var cmpEl = display.querySelector('[data-price-compare]');
      var saveEl = display.closest('.ctr-variant-picker__card');
      var saveSpan = saveEl ? saveEl.querySelector('[data-save-percent]') : null;

      if (curEl) curEl.textContent = formatMoney(prices.current);

      if (cmpEl) {
        if (prices.compare && prices.compare > prices.current) {
          cmpEl.textContent = formatMoney(prices.compare);
          cmpEl.style.display = '';
        } else {
          cmpEl.textContent = '';
          cmpEl.style.display = 'none';
        }
      }

      if (saveSpan) {
        if (prices.pct > 0) {
          saveSpan.textContent = 'You save ' + prices.pct + '%';
          saveSpan.style.display = '';
        } else {
          saveSpan.textContent = '';
          saveSpan.style.display = 'none';
        }
      }
    }

    function updateAll() {
      displays.forEach(updateCard);
    }

    /* ── Listeners ── */
    document.querySelectorAll('[data-purchase-option]').forEach(function (el) {
      el.addEventListener('change', updateAll);
    });

    var spSelect = document.querySelector('[data-selling-plan-select]');
    if (spSelect) spSelect.addEventListener('change', updateAll);

    document.addEventListener('ctr:price-update', updateAll);

    /* First paint + delayed retry for subscription form init */
    updateAll();
    setTimeout(updateAll, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
